<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
      <div class="inpBox">
        <el-form-item label="业务类型描述:" prop="description">
                <el-input  placeholder="" v-model="searchFrom.description"></el-input>
        </el-form-item>
         <el-form-item label="创建时间:" prop="createTime">
                    <el-date-picker
                      v-model="searchFrom.createTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
      </div>
       <div class="searchBtnBox">
         <el-form-item  btnCode="00FP002B001"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item >
         <el-form-item >
           <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
         </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
   <div class="table" :style="{height:h}">
     <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  height="100%" style="width: 100%" center>
       <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
       <el-table-column prop="tenantName" width="120" :show-overflow-tooltip="true" label="租户名称"></el-table-column>
       <el-table-column prop="enterpriseName" width="150" :show-overflow-tooltip="true"  label="企业名称"></el-table-column>
       <el-table-column prop="statusCode" label="返回结果状态码"></el-table-column>
       <el-table-column prop="description" width="120" :show-overflow-tooltip="true"  label="业务类型描述"></el-table-column>
       <el-table-column prop="createUserName" width="160" :show-overflow-tooltip="true"  label="创建人名称"></el-table-column>
       <el-table-column prop="createTime" width="160" :formatter="dateFormat"  label="创建时间"></el-table-column>
     </el-table>
   </div>
   <!-- 分页 -->
   <div>
     <el-pagination background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="searchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
     </el-pagination>
   </div>
 </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { signatureLogList } from '@/api/common-signature'
export default {
  data () {
    return {
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      tableList: [],
      btnFlg: [],
      btnIdArr: ['00FP002B001']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/signatureLog')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
    this.getList(this.searchFrom)
  },
  methods: {
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      signatureLogList(searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {

      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>

.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
